/* Added for official site: 「關於我們」頁面 (by Tanya) */
// 原檔名：slider-about.js

// 優化版：初始化牛肉特色輪播

// 1. 選取我們要觀察的目標元素 (輪播的容器)
const featureSlider = document.querySelector('.feature-slider');

// 2. 檢查目標是否存在於當前頁面
if (featureSlider) {
    
    // 3. 建立一個觀察者 (Intersection Observer)
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            
            // 4. 判斷目標是否「進入」了視窗
            if (entry.isIntersecting) {
                
                // 5. 在這裡初始化 Swiper
                const featureSwiper = new Swiper('.feature-slider', {
                    loop: true,
                    autoplay: {
                        delay: 3500,
                        disableOnInteraction: false,
                    },
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                });
                
                // 6. 停止觀察，因為任務已經完成
                observer.unobserve(featureSlider);
            }
        });
    });

    // 7. 命令觀察者開始「盯著」我們的目標元素
    observer.observe(featureSlider);
}